import React from "react";

const DiscoverByPayperviewCategorySkeleton = () => {
  return (
    <div>
      <div className="w-10 h-10 mb-5 rounded-full bg-[#1a1919] animate-pulse" />

      <div className="flex items-center justify-between mb-8 max-sm:block w-[98%]">
        <div className="h-7 w-[280px] max-w-full animate-pulse rounded bg-[#1a1919] max-sm:mb-5" />
        <div className="h-10 w-[160px] animate-pulse rounded-full bg-[#1a1919]" />
      </div>

      <div className="grid w-full grid-cols-2 mt-4 mb-28 gap-4 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-4 xl:grid-cols-4 2xl:grid-cols-4 max-sm:w-full">
        {Array.from({ length: 12 }).map((_, i) => (
          <div key={i} className="mb-5 mr-4 w-full">
            <div className="aspect-video w-full animate-pulse rounded-xl bg-[#1a1919]" />
            <div className="px-1 pb-4 pt-[14px]">
              <div className="h-4 w-[90%] animate-pulse rounded bg-[#1a1919]" />
              <div className="mt-2 h-4 w-[60%] animate-pulse rounded bg-[#1a1919]" />
              <div className="mt-3 flex items-center justify-between gap-2">
                <div className="h-3 w-[45%] animate-pulse rounded bg-[#1a1919]" />
                <div className="h-5 w-[70px] shrink-0 animate-pulse rounded-full bg-[#1a1919]" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DiscoverByPayperviewCategorySkeleton;
